module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticClass: "white--text direct-file-upload-btn",
    class: {
      'direct-file-upload-btn--icon-only': _vm.iconOnly
    },
    attrs: {
      "small": "",
      "depressed": "",
      "color": "secondary",
      "aria-label": _vm.iconOnly ? 'Upload files' : null,
      "title": _vm.iconOnly ? 'Upload files' : null
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [(!_vm.iconOnly) ? _c('span', [_vm._v(_vm._s(_vm.title ? _vm.title : 'Browse'))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "right": !_vm.iconOnly,
      "dark": ""
    }
  }, [_vm._v("\n      mdi-folder-open-outline\n    ")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "media",
      "id": "fileToUpload",
      "accept": "image/*, .pdf, .ppt, .txt, .doc, .docx",
      "multiple": _vm.multiple || false
    },
    on: {
      "change": _vm.prepareUpload
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29e75ff2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/custom/DirectFileUpload.vue
// module id = 2051
// module chunks = 0